import useCurrentPersonInfo from "./useCurrentPersonInfo";
const useCurrentApiUser = () => { var _a; return (_a = useCurrentPersonInfo().data) === null || _a === void 0 ? void 0 : _a.person; };
export default useCurrentApiUser;
